var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-app',[_c('ion-content',[_c('EducationPatientHeader'),_c('div',{staticClass:"center-center"},[_c('ion-spinner',{attrs:{"name":"dots","duration":"1200"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }